/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
import React, { useState, useCallback } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from 'react-i18next';

import Grid from "@material-ui/core/Grid";
import debounce from "lodash.debounce";
import update from "immutability-helper";
import axios from "axios";
import Cookies from "js-cookie";

// Material UI
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { date } from "joi";
import { Board } from "../../data/Board";

import {
  DiamondSm,
  DownArrow,
  ConstraintLog,
  GateLog,
  MillstoneLog,
  PlannedTaskLog,
  RiskLog,
  UnplannedTaskLog,
  DelayLog,
  MiddleTurnLog,
} from "../../Constants/assets";

const AccordionOuter = styled(Accordion)`
  && {
    /* Styles Override */
    box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin-bottom: 8px;
    page-break-inside: avoid;
  }

  :before {
    display: none;
  }
`;

const LogoNumber = styled.div`
  font-size: 12px;
  position: relative;
`;

const AccordionSummaryCustom = styled(AccordionSummary)`
  &&& {
    /* Styles Override */
    padding: 0;
    margin: 0;
    align-items: center;
    min-height: 48px;

    .MuiAccordionSummary-root.Mui-expanded,
    .MuiAccordionSummary-content.Mui-expanded,
    .Mui-expanded {
      margin: 0;
      min-height: 0;
    }
  }
`;

const AccordionDetailsCustom = styled(AccordionDetails)`
  &&& {
    padding: 0;
    justify-content: center;
    border-top: 1px solid ${(props) => props.theme.colors.whiteSmoke};
    min-height: 227px;
    align-items: end;
  }
`;

const InnerContainer = styled.tr`
margin: 0px 10px 0px 10px;
display: flex;
width: 98%;
height: 100%;
align-items: center;
justify-content: space-between;
box-sizing: border-box;
  color: ${(props) => props.mileStoneStyle?.code == 8 && props.mileStoneStyle?.NotLanded == 1 ? '#81818c !important' : ''};
`;
const ReportColumn = styled.div`
  font-size: 14px;
`;

// details styling
const DetailsContainer = styled.div`
  /* margin: 12px 0; */
  display: grid;
  width: 93.4%;
  height: 200px;
  /* height: 227px; */
`;
const DetailsLine = styled.div`
  display: flex;
`;
const SubjectTitle = styled.div`
  color: ${(props) => props.theme.colors.gray};
`;
const SubjectContainer = styled.div`
  margin-right: 5%;
  font-size: 14px;
`;
const Subject = styled.div`
  font-size: 14px;
`;
const CommentLine = styled.div``;

export default function ReportsLabels({ data, setRef, expand, commentsList }) {
  const { t } = useTranslation();

  const buyInPause = () => {
    let result;
    const totalBuy = Math.abs(data.cost);
    const totalRegular = Math.abs(data.spentRegular);
    const totalSenior = Math.abs(data.spentSenior);
    const totalexecutive = Math.abs(data.spentExpensive);
    if (
      totalRegular * 100 + totalSenior * 200 + totalexecutive * 500 ==
      totalBuy
    ) {
      // console.log('true');
      result = true;
    } else {
      // console.log('false');
      result = false;
    }
    return result;
  };
  // console.log('code', data.code, buyInPause());
  const translationCodeToAction = {
    0: "empty",
    1: "empty",
    2: "Planned",
    3: "Unplanned",
    4: "Risk",
    5: "Constraint",
    6: "Delay",
    // 7: 'GetBudget',
    8: "Milestone",
    9: "Gate",
    10: "BuyResources",
    11: "General",
    12: "empty", // those are the comments
    13: "Gate",
  };
  const insertVariablesToTranslation = (TranslatedComment, originalComment) => {
    if (TranslatedComment.includes("$x")) {
      const numericMatch = originalComment.match(/\d+/); // Extract numeric value
      if (numericMatch && numericMatch.length > 0) {
        TranslatedComment = TranslatedComment.replace("$x", numericMatch[0] + "$");
      }
    }
    return TranslatedComment;
  };

  const resolveCommentRow = (index) => {
    const byId =
      index.comment_id != null && index.comment_id !== undefined
        ? commentsList.find((c) => Number(c.id) === Number(index.comment_id))
        : null;
    if (byId) return byId;
    return commentsList.find(
      (comment) =>
        insertVariablesToTranslation(comment.value, index.value) === index.value,
    );
  };

  const { turnData } = data;
  const { cardData } = data;
  if (turnData && turnData.code == 21) return null;
  return (
    <AccordionOuter
      // style={{ padding: '0px !important' }}
      expandIcon={
        <DownArrow
          style={{
            cursor: "pointer",
          }}
        />
      }
    >
      <AccordionSummaryCustom aria-expanded={expand} ref={setRef}>
        <InnerContainer mileStoneStyle={{ code: turnData.code, NotLanded: turnData.decision }}>
          <td style={{ width: '5%' }}>
            {(turnData.code == 10 || turnData.code == 7) && buyInPause() && (
              <ReportColumn />
            )}
            {(turnData.code == 10 || turnData.code == 7) && !buyInPause() && (
              <ReportColumn>
                {turnData.turnNumber}
              </ReportColumn>
            )}
            {turnData.code != 10 && turnData.code != 7 && (
              <ReportColumn>
                {turnData.turnNumber}
              </ReportColumn>
            )}
          </td>
          <td style={{ width: '7%' }}>
            {buyInPause() && turnData.code == 10 && (
              <ReportColumn>
                <MiddleTurnLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                  }}
                />
              </ReportColumn>
            )}
            {((turnData.value == 1 && turnData.code == 7) ||
              (turnData.value == 1 && turnData.code == 10)) && (
                <ReportColumn>
                  <MiddleTurnLog
                    style={{
                      position: "relative",
                      width: "40px",
                      height: "40px",
                    }}
                  />
                </ReportColumn>
              )}
            {/* {!buyInPause() && turnData.code == 10 && (
                              <ReportColumn style={{ width: '7%' }} />
                          )} */}
            {turnData.code == 2 && turnData.type != "gate" && (
              <ReportColumn>
                <PlannedTaskLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: "#005857",
                    transform:
                      turnData.spotNumber < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {turnData.spotNumber}
                </LogoNumber>
              </ReportColumn>
            )}
            {turnData.code == 3 && (
              <ReportColumn>
                <UnplannedTaskLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: "white",
                    transform:
                      turnData.spotNumber < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {turnData.spotNumber}
                </LogoNumber>
              </ReportColumn>
            )}
            {turnData.code == 4 && (
              <ReportColumn>
                <RiskLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: "white",
                    transform:
                      turnData.spotNumber < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {turnData.spotNumber}
                </LogoNumber>
              </ReportColumn>
            )}
            {turnData.code == 8 && (
              <ReportColumn>
                <MillstoneLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: turnData.decision == 1 ? "#81818c" : "white",
                    transform:
                      turnData.spotNumber < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {turnData.spotNumber}
                </LogoNumber>
              </ReportColumn>
            )}
            {(turnData.code == 9 ||
              turnData.code == 13 ||
              turnData.type == "gate") &&
              (turnData.code != 10 && turnData.code != 7 && turnData.code != 21) && (
                <ReportColumn>
                  <GateLog
                    style={{
                      position: "relative",
                      width: "40px",
                      height: "40px",
                      transform: "translate(0px, 7px)",
                    }}
                  />
                  {console.log("we have gate, with turn data", turnData)}
                  <LogoNumber
                    style={{
                      color: "white",
                      transform:
                        turnData.spotNumber < 10
                          ? "translate(1.4em, -1.8em)"
                          : "translate(1.1em, -1.8em)",
                    }}
                  >
                    {turnData.spotNumber}
                  </LogoNumber>
                </ReportColumn>
              )}
            {turnData.code == 5 && (
              <ReportColumn>
                <ConstraintLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: "white",
                    transform:
                      turnData.spotNumber < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {turnData.spotNumber}
                </LogoNumber>
              </ReportColumn>
            )}
            {turnData.code == 6 && cardData && turnData.type != "gate" && (
              <ReportColumn>
                {turnData && turnData.type == "planned-task" && (
                  <>
                    <PlannedTaskLog
                      style={{
                        position: "relative",
                        width: "40px",
                        height: "40px",
                        transform: "translate(0px, 7px)",
                      }}
                    />
                    <LogoNumber
                      style={{
                        color: "#005857",
                        transform:
                          turnData.spotNumber < 10
                            ? "translate(1.4em, -1.8em)"
                            : "translate(1.1em, -1.8em)",
                      }}
                    >
                      {turnData.spotNumber}
                    </LogoNumber>
                  </>
                )}
                {turnData && turnData.type == "Risk" && (
                  <>
                    <RiskLog
                      style={{
                        position: "relative",
                        width: "40px",
                        height: "40px",
                        transform: "translate(0px, 7px)",
                      }}
                    />
                    <LogoNumber
                      style={{
                        color: "white",
                        transform:
                          turnData.spotNumber < 10
                            ? "translate(1.4em, -1.8em)"
                            : "translate(1.1em, -1.8em)",
                      }}
                    >
                      {turnData.spotNumber}
                    </LogoNumber>
                  </>
                )}
                {turnData && turnData.type == "unplanned-task" && (
                  <>
                    <UnplannedTaskLog
                      style={{
                        position: "relative",
                        width: "40px",
                        height: "40px",
                        transform: "translate(0px, 7px)",
                      }}
                    />
                    <LogoNumber
                      style={{
                        color: "white",
                        transform:
                          turnData.spotNumber < 10
                            ? "translate(1.4em, -1.8em)"
                            : "translate(1.1em, -1.8em)",
                      }}
                    >
                      {turnData.spotNumber}
                    </LogoNumber>
                  </>
                )}
                {turnData && turnData.type == "Constraint" && (
                  <>
                    <ConstraintLog
                      style={{
                        position: "relative",
                        width: "40px",
                        height: "40px",
                        transform: "translate(0px, 7px)",
                      }}
                    />
                    <LogoNumber
                      style={{
                        color: "white",
                        transform:
                          turnData.spotNumber < 10
                            ? "translate(1.4em, -1.8em)"
                            : "translate(1.1em, -1.8em)",
                      }}
                    >
                      {turnData.spotNumber}
                    </LogoNumber>
                  </>
                )}
                {turnData && turnData.type == "mile-stone" && (
                  <>
                    <MillstoneLog
                      style={{
                        position: "relative",
                        width: "40px",
                        height: "40px",
                        transform: "translate(0px, 7px)",
                      }}
                    />
                    <LogoNumber
                      style={{
                        color: "white",
                        transform:
                          turnData.spotNumber < 10
                            ? "translate(1.4em, -1.8em)"
                            : "translate(1.1em, -1.8em)",
                      }}
                    >
                      {turnData.spotNumber}
                    </LogoNumber>
                  </>
                )}
                {/* {turnData && turnData.type == 'gate' && (
                                      <>
                                          <GateLog
                                              style={{
                                                  position: 'relative',
                                                  width: '40px',
                                                  height: '40px',
                                                  transform: 'translate(0px, 7px)',
                                              }}
                                          />
                                          <LogoNumber
                                              style={{
                                                  color: 'white',
                                                  transform:
                                                      turnData.spotNumber < 10
                                                          ? 'translate(1.4em, -1.8em)'
                                                          : 'translate(1.1em, -1.8em)',
                                              }}
                                          >
                                              {turnData.spotNumber}
                                          </LogoNumber>
                                      </>
                                  )} */}
              </ReportColumn>
            )}
            {/* general PM task start */}
            {turnData.code == 11 && turnData && turnData.type === "mile-stone" && (
              <ReportColumn>
                <MillstoneLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: "#ffffff",
                    transform:
                      turnData.spotNumber < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {turnData.spotNumber}
                </LogoNumber>
              </ReportColumn>
            )}
            {turnData &&
              turnData.code == 11 &&
              turnData.type === "gate" &&
              (turnData.code != 10 && turnData.code != 7 && turnData.code != 21) && (
                <ReportColumn>
                  <GateLog
                    style={{
                      position: "relative",
                      width: "40px",
                      height: "40px",
                      transform: "translate(0px, 7px)",
                    }}
                  />
                  <LogoNumber
                    style={{
                      color: "#ffffff",
                      transform:
                        turnData.spotNumber < 10
                          ? "translate(1.4em, -1.8em)"
                          : "translate(1.1em, -1.8em)",
                    }}
                  >
                    {data.spotNum}
                  </LogoNumber>
                </ReportColumn>
              )}
            {turnData.code == 11 &&
              turnData &&
              turnData.type === "planned-task" && (
                <ReportColumn>
                  <PlannedTaskLog
                    style={{
                      position: "relative",
                      width: "40px",
                      height: "40px",
                      transform: "translate(0px, 7px)",
                    }}
                  />
                  <LogoNumber
                    style={{
                      color: "#005857",
                      transform:
                        turnData.spotNumber < 10
                          ? "translate(1.4em, -1.8em)"
                          : "translate(1.1em, -1.8em)",
                    }}
                  >
                    {turnData.spotNumber}
                  </LogoNumber>
                </ReportColumn>
              )}
            {turnData.code == 11 && turnData && turnData.type === "Risk" && (
              <ReportColumn>
                <RiskLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: "#ffffff",
                    transform:
                      data.spotNum < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {data.spotNum}
                </LogoNumber>
              </ReportColumn>
            )}
            {turnData.code == 11 &&
              turnData &&
              turnData.type === "unplanned-task" && (
                <ReportColumn>
                  <UnplannedTaskLog
                    style={{
                      position: "relative",
                      width: "40px",
                      height: "40px",
                      transform: "translate(0px, 7px)",
                    }}
                  />
                  <LogoNumber
                    style={{
                      color: "#ffffff",
                      transform:
                        turnData.spotNumber < 10
                          ? "translate(1.4em, -1.8em)"
                          : "translate(1.1em, -1.8em)",
                    }}
                  >
                    {turnData.spotNumber}
                  </LogoNumber>
                </ReportColumn>
              )}
            {turnData.code == 11 && turnData && turnData.type === "Constraint" && (
              <ReportColumn>
                <ConstraintLog
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "40px",
                    transform: "translate(0px, 7px)",
                  }}
                />
                <LogoNumber
                  style={{
                    color: "#ffffff",
                    transform:
                      turnData.spotNumber < 10
                        ? "translate(1.4em, -1.8em)"
                        : "translate(1.1em, -1.8em)",
                  }}
                >
                  {turnData.spotNumber}
                </LogoNumber>
              </ReportColumn>
            )}
          </td>
          <td style={{ width: '12%' }}>
            {turnData.code == 11 && (
              <ReportColumn>
                {t('global_variables.game_element.general_task')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 4 && (
              <ReportColumn>
                {t('global_variables.game_element.risk')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 10 && (
              <ReportColumn>
                {t('global_variables.actions.additional_resources')}
              </ReportColumn>
            )}
            {turnData.code == 7 && (
              <ReportColumn style={{ width: '60%' }}>
                {t('global_variables.actions.additional_budget')}
              </ReportColumn>
            )}
            {turnData.code == 2 && (
              <ReportColumn>
                {t('global_variables.game_element.planned_task')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 3 && (
              <ReportColumn>
                {t('global_variables.game_element.unplanned_task')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 5 && (
              <ReportColumn>
                {t('global_variables.game_element.constraint')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 6 && (
              <ReportColumn>
                {t('global_variables.game_element.delay')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 8 && (
              <ReportColumn mileStoneStyle={{ code: turnData.code, NotLanded: turnData.decision }}>

                {t('global_variables.game_element.milestone')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 9 && (
              <ReportColumn>
                {t('global_variables.game_element.gate')} #{turnData.value}
              </ReportColumn>
            )}
            {turnData.code == 13 && (
              <ReportColumn>
                {t('global_variables.game_element.gate')} #{turnData.value}
              </ReportColumn>
            )}
          </td>
          <td style={{ width: '5%' }}>
            {cardData && cardData.costMoney < 0 && (
              <ReportColumn style={{ color: "#A90821" }}>
                $ {Math.abs(cardData.costMoney)}
              </ReportColumn>
            )}
            {cardData && cardData.costMoney >= 0 && (
              <ReportColumn style={{ color: "#005857" }}>
                $ {Math.abs(cardData.costMoney ? cardData.costMoney : 0)}
              </ReportColumn>
            )}
          </td>
          <td style={{ width: '12.5%', textAlign: 'center' }}>
            {cardData && cardData.costResourcesNormal >= 0 && (
              <ReportColumn style={{ color: "#005857" }}>

                {Math.abs(
                  cardData.costResourcesNormal
                    ? cardData.costResourcesNormal
                    : 0
                )}
              </ReportColumn>
            )}
            {cardData && cardData.costResourcesNormal < 0 && (
              <ReportColumn style={{ color: "#A90821" }}>

                {Math.abs(cardData.costResourcesNormal)}
              </ReportColumn>
            )}
          </td>
          <td style={{ width: '12.5%', textAlign: 'center' }}>
            {cardData && cardData.costResourcesSenior >= 0 && (
              <ReportColumn style={{ color: "#005857" }}>

                {Math.abs(
                  cardData.costResourcesSenior
                    ? cardData.costResourcesSenior
                    : 0
                )}
              </ReportColumn>
            )}
            {cardData && cardData.costResourcesSenior < 0 && (
              <ReportColumn style={{ color: "#A90821" }}>

                {Math.abs(cardData.costResourcesSenior)}
              </ReportColumn>
            )}
          </td>
          <td style={{ width: '12.5%', textAlign: 'center', marginRight: '3%' }}>
            {cardData && cardData.costResourcesExpensive >= 0 && (
              <ReportColumn style={{ color: "#005857" }}>

                {Math.abs(
                  cardData.costResourcesExpensive
                    ? cardData.costResourcesExpensive
                    : 0
                )}
              </ReportColumn>
            )}
            {cardData && cardData.costResourcesExpensive < 0 && (
              <ReportColumn style={{ color: "#A90821" }}>

                {Math.abs(cardData.costResourcesExpensive)}
              </ReportColumn>
            )}
          </td>
          <td style={{ width: '5%' }}>
            <ReportColumn style={{ display: 'flex', alignItems: 'center' }}>
              <DiamondSm />
              <div style={{ marginLeft: '5px' }}>
                {cardData && cardData.earnedValue ? cardData.earnedValue : 0}
              </div>
            </ReportColumn>
          </td>
          <td style={{ width: '11%', textAlign: 'center' }}>
            <ReportColumn>
              {cardData?.steps ?? ""}
            </ReportColumn>
          </td>
          <td style={{ width: '7%', display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>
            <ReportColumn>
              {turnData.comment ? ( // && turnData.comment.length > 0
                <div>
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "17px",
                      height: "17px",
                      background: "#A90821",
                      borderRadius: "50%",
                      color: "white",
                    }}
                  >
                    <div style={{ position: "absolute" }}>
                      {turnData.comment ? turnData.comment.length : 0}
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ width: "17px", height: "17px" }} />
              )}
            </ReportColumn>
          </td>
          <td style={{ width: '3%', textAlign: 'center' }}>
            <ReportColumn>
              <DownArrow
                style={{
                  cursor: "pointer",
                }}
                aria-label="Sort descending"
              />
            </ReportColumn>
          </td>
        </InnerContainer>
      </AccordionSummaryCustom>
      <AccordionDetailsCustom>
        <DetailsContainer style={{ height: "calc(max-content + 20px)" }}>
          <DetailsLine>
            <SubjectContainer>
              <SubjectTitle>{t(`report.detailed_report.action_information.remaining_budget`)}</SubjectTitle>
              <Subject> $ {turnData.budget} </Subject>
            </SubjectContainer>
            <SubjectContainer>
              <SubjectTitle>{t(`report.detailed_report.action_information.remaining_standard`)}</SubjectTitle>
              <Subject> {turnData.regular} </Subject>
            </SubjectContainer>
            <SubjectContainer>
              <SubjectTitle>{t(`report.detailed_report.action_information.remaining_senior`)}</SubjectTitle>
              <Subject> {turnData.senior} </Subject>
            </SubjectContainer>
            <SubjectContainer>
              <SubjectTitle>{t(`report.detailed_report.action_information.remaining_executive`)}</SubjectTitle>
              <Subject> {turnData.expensive} </Subject>
            </SubjectContainer>
            <SubjectContainer>
              <SubjectTitle>{t(`report.detailed_report.action_information.total_value`)}</SubjectTitle>
              <Subject>
                {turnData.earnedValue} <DiamondSm />
              </Subject>
            </SubjectContainer>
            <SubjectContainer>
              <SubjectTitle>{t(`report.detailed_report.action_information.action_time`)}</SubjectTitle>
              <Subject>
                {`0${Math.floor(turnData.local_timer / 3600)}`}:{""}
                {Math.floor(turnData.local_timer / 60) > 9
                  ? `${Math.floor(turnData.local_timer / 60)}`.replace(".", "")
                  : `0${Math.floor(turnData.local_timer / 60)}`.replace(
                    ".",
                    ""
                  )}
                :{""}
                {Math.floor(turnData.local_timer % 60) > 9
                  ? `${Math.floor(turnData.local_timer % 60)}`
                  : `0${Math.floor(turnData.local_timer % 60)}`}
              </Subject>
            </SubjectContainer>
          </DetailsLine>
          <DetailsLine style={{ maxHeight: "125px", overflowY: "auto" }}>
            <SubjectContainer>
              <SubjectTitle>{t(`report.detailed_report.action_information.comments`)}</SubjectTitle>
              {turnData.comment &&
                turnData.comment.map((index, commentIdx) => {
                  const findComment = resolveCommentRow(index);
                  if (!findComment) {
                    return (
                      <CommentLine
                        key={`${turnData.id}-c-${commentIdx}`}
                        style={{ marginRight: "-8.5%" }}
                      >
                        {index.value}
                      </CommentLine>
                    );
                  }
                  return (
                    <CommentLine
                      key={`${turnData.id}-c-${findComment.id}-${commentIdx}`}
                      style={{ marginRight: "-8.5%" }}
                    >
                      {insertVariablesToTranslation(
                        t(`report.detailed_report.comments.${findComment.id}`, {
                          findComment: findComment.id,
                        }),
                        index.value,
                      )}
                    </CommentLine>
                  );
                })}
            </SubjectContainer>
          </DetailsLine>
        </DetailsContainer>
      </AccordionDetailsCustom>
    </AccordionOuter>
  );
}
